"use client";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./popular.css";
import playwhite from "../../assets/images/playwhite.png";
import popurlar from "../../assets/images/popurlar.svg";


export default function Popular({ games = [], categories = [] }) {
  const containerRef = useRef(null);
  const cardsRef = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(5);

  // Filter popular games
const popularGames = games
  .filter((game) => game.popular > 0)
  .sort((a, b) => a.popular - b.popular);
  const getCategoryName = (gameType) => {
    const idStr = String(gameType);
    const found = categories.find((c) => String(c.id) === idStr);
    return found ? found.gametype : "Unknown";
  };



  useEffect(() => {
    if (!cardsRef.current[0]) return;
    const cardWidth = cardsRef.current[0].offsetWidth;
    containerRef.current.style.transform = `translateX(-${currentIndex * (cardWidth + 20)
      }px)`;
  }, [currentIndex, cardsPerView]);

  const next = () => {
    if (currentIndex < popularGames.length - cardsPerView) {
      setCurrentIndex((i) => i + 1);
    }
  };



  // Don't render if no popular games
  if (popularGames.length === 0) {
    return null;
  }

  return (
    <>

      <div className="slider-container POPCONT">
        <div className="slider-header">
          <div className="popularDiv">
            <div className="popurlarBTN">
              <img src={popurlar} alt="" className="popurlar" /> Popular Games
            </div>
          </div>
        </div>



        <div className="slider-wrapper POPslider">


          <div className="NEWTAB_container">


            <div  className="NEWTAB_galleryPOP" aria-live="polite">


              {popularGames.map((game, i) => (
          

                <div className={`NEWTAB_item NEWTAB_cat`} key={game.id}>
                  <Link to={`/games/${encodeURIComponent(game.gamename)}`} style={{width:"100%"}}>
                  <div className="NEWTAB_card">

                    <div className="de-item s2">
                      <div className="parenteBOx magiC">


                        <img
                          className="NEWTAB_img"
                        src={game.image}
                          alt={game.titlename}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                          }}
                        />

                        <button className="GameBTnNormal">
                          <div className="button-content">
                            <div className="icon-wrapper">
                              <img src={playwhite} alt="" className="PlaybuttonHover1" />
                            </div>
                          </div>

                        </button>

                      </div>
                      <div className="ChildBOx">
                        <div className="tiTle">{game.titlename}</div>
                        <div className="SubtiTle">
                          {game.game_type_name}
                        </div>
                      </div>
                    </div>

                  </div>
                  </Link>
                </div>

              ))}

            </div>
          </div>
        </div>



      </div>
    </>
  );
}